import { hot } from "react-hot-loader";

import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import { number } from "prop-types";
import "isomorphic-fetch";

import apolloClient from "src/shared/utilities/graphql/apolloClient";

import RentalContactContainer from "../RentalContactContainer";
import RentalContactQuery from "../RentalContactQuery";

const App = ({ listingId }) => (
  <ApolloProvider client={apolloClient}>
    <RentalContactQuery listingId={listingId}>
      {({ data }) => <RentalContactContainer data={data} />}
    </RentalContactQuery>
  </ApolloProvider>
);

App.propTypes = {
  listingId: number.isRequired
};

export default hot(module)(App);
